import { Box, Collapse, IconButton, InputAdornment, TextField } from '@mui/material';
import { hexToRGBA } from 'src/utils/all';
import { useMenuContext } from '../context';

type Props = {
  searchText: string;
  searchBar: boolean;
  setSearchText: (searchText: string) => void;
};

export const SearchBar = ({ searchText, searchBar, setSearchText }: Props) => {
  const { colors, translation } = useMenuContext();

  return (
    <Box>
      <Collapse in={searchBar} unmountOnExit>
        <Box
          sx={{
            borderTop: `1px solid ${hexToRGBA(colors.bg, 0.2)}`,
            borderBottom: `1px solid ${hexToRGBA(colors.bg, 0.2)}`
          }}
        >
          <TextField
            variant="standard"
            fullWidth
            placeholder={translation?.searchMenu || 'Search...'}
            sx={{
              background: hexToRGBA(colors.bg, 0.06)
            }}
            value={searchText}
            inputProps={{
              style: {
                color: colors.text,
                height: 45,
                padding: '0px 10px'
              }
            }}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              ...(searchText && {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      sx={{
                        marginRight: 2,
                        color: 'lightgray'
                      }}
                      onClick={() => {
                        setSearchText('');
                      }}
                    >
                      <i className="fas fa-times" />
                    </IconButton>
                  </InputAdornment>
                )
              })
            }}
          />
        </Box>
      </Collapse>
    </Box>
  );
};
